import * as moment from "moment";
import { DateTime } from "enums";

// POST /resource/status-history/graph/venue/{id} -- plot is one map per time bucket,
// {bucketKey: {stateName: totalSecondsSpentInThatStateEndingInThisBucket}}. State names are
// free-form per venue, so this flattens into rows + the observed set of state columns
// rather than assuming fixed categories.
export const resourceOccupancyGraph = {
  rows: {
    transform: ({ src }) => {
      const rawPlot = src?.plot || [];
      return rawPlot.map((entry) => {
        const [bucketKey, stateSeconds] = Object.entries(entry)[0] || ["-", {}];
        return { bucketKey, ...stateSeconds };
      });
    },
  },
  stateKeys: {
    transform: ({ src }) => {
      const rawPlot = src?.plot || [];
      const keys = new Set();
      rawPlot.forEach((entry) => {
        const [, stateSeconds] = Object.entries(entry)[0] || ["-", {}];
        Object.keys(stateSeconds || {}).forEach((k) => keys.add(k));
      });
      return Array.from(keys);
    },
  },
};

// POST /resource/status-history/kpi/venue/{id}
export const resourceStatusKpi = {
  totalTransitionCount: { key: "totalTransitionCount" },
  avgDurationSecondsByState: { key: "avgDurationSecondsByState" },
  transitionCountByToState: { key: "transitionCountByToState" },
  currentStateDistribution: { key: "currentStateDistribution" },
};

// GET /resource/{id}/status-history/timeline -- one row per transition.
export const resourceStatusTimelineEntry = {
  fromState: { key: "fromState" },
  toState: { key: "toState" },
  changedAt: {
    transform: ({ src }) => (src.changedAt ? moment(src.changedAt).format(DateTime.A) : "-"),
  },
  previousStateDurationSeconds: { key: "previousStateDurationSeconds" },
  reason: { key: "reason" },
  deviceId: { key: "deviceId" },
  actorType: { key: "actorType" },
};
